import { Chart } from '@amcharts/amcharts4/charts';
import { Component, Input, OnInit } from '@angular/core';
import { Energy } from 'src/app/performance-dashboard/model/performance.model';
import { PerformanceService } from '../../../services/performance.service';
import { ConstantsService } from '../../../../shared/services/constants.service';
import { Router } from '@angular/router';
import * as XLSX from 'xlsx';

@Component({
  selector: 'ara-energy-consumption',
  templateUrl: './energy-consumption.component.html',
  styleUrls: ['./energy-consumption.component.css']
})
export class EnergyConsumptionComponent implements OnInit {
  @Input() energyData;
  @Input() selectedUnit: any;
  @Input() year: any;
  @Input() MonthRange: any;
  clonedEnergyData: { [s: string]: Energy } = {};
  EnergyConsumptionData : any;
  DisableExport : boolean = false;

  constructor(private PDService: PerformanceService,private router: Router) { }

  ngOnInit(): void {
  }

  onRowEditInit(energy: Energy) {
    this.clonedEnergyData[energy.Id] = { ...energy };
    this.DisableExport = true;
  }

  onRowEditSave(energy: Energy, index: number) {
    if (energy) {
      delete this.clonedEnergyData[energy.Id];

      let newEnergyData = [];
      this.energyData.forEach(element => {
        if(element.category !== "Total")
        newEnergyData.push(element);
      });

      this.energyData[this.energyData.length - 1].NaturalGasProd = newEnergyData.reduce((acc, cur) => acc + cur.NaturalGasProd, 0);
      this.energyData[this.energyData.length - 1].FuelGasGen = newEnergyData.reduce((acc, cur) => acc + cur.FuelGasGen, 0);
      this.energyData[this.energyData.length - 1].FuelGasTreater = newEnergyData.reduce((acc, cur) => acc + cur.FuelGasTreater, 0);
      this.energyData[this.energyData.length - 1].AllGasFlared = newEnergyData.reduce((acc, cur) => acc + cur.AllGasFlared, 0);
      this.energyData[this.energyData.length - 1].TotalProducedWater = newEnergyData.reduce((acc, cur) => acc + cur.TotalProducedWater, 0);
      this.energyData[this.energyData.length - 1].PWReInjected = newEnergyData.reduce((acc, cur) => acc + cur.PWReInjected, 0);
      this.energyData[this.energyData.length - 1].PWEvaporated = newEnergyData.reduce((acc, cur) => acc + cur.PWEvaporated, 0);
      this.energyData[this.energyData.length - 1].WaterAbstracted = newEnergyData.reduce((acc, cur) => acc + cur.WaterAbstracted, 0);
      this.energyData[this.energyData.length - 1].EPFDGS = newEnergyData.reduce((acc, cur) => acc + cur.EPFDGS, 0);
      this.energyData[this.energyData.length - 1].CampDGS = newEnergyData.reduce((acc, cur) => acc + cur.CampDGS, 0);
      this.energyData[this.energyData.length - 1].ContractorDGS = newEnergyData.reduce((acc, cur) => acc + cur.ContractorDGS, 0);
      this.energyData[this.energyData.length - 1].Vehicle = newEnergyData.reduce((acc, cur) => acc + cur.Vehicle, 0);
      this.energyData[this.energyData.length - 1].Other = newEnergyData.reduce((acc, cur) => acc + cur.Other, 0);
      this.energyData[this.energyData.length - 1].WellsDGS = newEnergyData.reduce((acc, cur) => acc + cur.WellsDGS, 0);
      this.energyData[this.energyData.length - 1].WaterConsumption = newEnergyData.reduce((acc, cur) => acc + cur.WaterConsumption, 0);
      this.energyData[this.energyData.length - 1].StationarySource = newEnergyData.reduce((acc, cur) => acc + cur.StationarySource, 0);
      this.energyData[this.energyData.length - 1].Generators = newEnergyData.reduce((acc, cur) => acc + cur.Generators, 0);
      this.energyData[this.energyData.length - 1].MainsElectricityEPF = newEnergyData.reduce((acc, cur) => acc + cur.MainsElectricityEPF, 0);
      this.energyData[this.energyData.length - 1].MainsElectricityCamp = newEnergyData.reduce((acc, cur) => acc + cur.MainsElectricityCamp, 0);
      this.energyData[this.energyData.length - 1].MainsElectricityWells = newEnergyData.reduce((acc, cur) => acc + cur.MainsElectricityWells, 0);
    }
    this.DisableExport = Object.keys(this.clonedEnergyData).length > 0 ? true : false;
  }

  onRowEditCancel(energy: Energy, index: number) {
    this.energyData[index] = this.clonedEnergyData[energy.Id];
    delete this.clonedEnergyData[energy.Id];
    this.DisableExport = Object.keys(this.clonedEnergyData).length > 0 ? true : false;
  }

  GetEnergyConsumptionSelectedDetails(UnitId,Unit,Column){
  
    const apiRequest = {
      Model: {
        "Units": this.selectedUnit,//this.child1.selectedUnit,
        "Year": this.year,//this.child1.year,
        "Months":this.MonthRange,//this.child1.MonthRange,
        "ModuleName":"Energy Consumption",
        "Component":Unit === "Total" ? 0 : UnitId,
        "Column":Column,
        "ComponentName":Unit
     }
    };

    this.PDService.getPDSelectedDetails(apiRequest,this.callbackMethodForGetEnergyConsumptionSelectedDetails.bind(this));
  }
  callbackMethodForGetEnergyConsumptionSelectedDetails(response){
    if(response.Success)
    this.EnergyConsumptionData = response.Result;
  }

  Redirect(value,UnitId)
  {
 // this.router.navigate(['/pd/statistic/', value, { unitId:UnitId }])
  window.open(ConstantsService.URL.APP + ['/pd/statistic/'+value+';unitId='+UnitId], '_self');
  }

  //BOC Pritesh
  exportToExcel()
  {

  let element = document.getElementById('EnergyConsumptionTableToExport');
  const ws: XLSX.WorkSheet =XLSX.utils.table_to_sheet(element);
 
  ws['!ref'] = ws['!ref'].replace('V','U');//to remove Actions Column
  /* generate workbook and add the worksheet */
  const wb: XLSX.WorkBook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

  /* save to file */  
  XLSX.writeFile(wb, "EnergyConsumption.xlsx");

  }
  //EOC Pritesh

}
